//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.AllVesselNameQuery
import kotlin.Any
import kotlin.String
import kotlin.collections.List

public object AllVesselNameQuery_ResponseAdapter {
  public object Data : Adapter<AllVesselNameQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("allVesselName")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): AllVesselNameQuery.Data {
      var _allVesselName: List<AllVesselNameQuery.AllVesselName>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _allVesselName = AllVesselName.obj().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return AllVesselNameQuery.Data(
        allVesselName = _allVesselName ?: missingField(reader, "allVesselName")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: AllVesselNameQuery.Data,
    ) {
      writer.name("allVesselName")
      AllVesselName.obj().list().toJson(writer, customScalarAdapters, value.allVesselName)
    }
  }

  public object AllVesselName : Adapter<AllVesselNameQuery.AllVesselName> {
    public val RESPONSE_NAMES: List<String> = listOf("id", "name")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): AllVesselNameQuery.AllVesselName {
      var _id: Any? = null
      var _name: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _name = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return AllVesselNameQuery.AllVesselName(
        id = _id ?: missingField(reader, "id"),
        name = _name ?: missingField(reader, "name")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: AllVesselNameQuery.AllVesselName,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("name")
      StringAdapter.toJson(writer, customScalarAdapters, value.name)
    }
  }
}
